import CalendarType from "@/managers/data/preferences/calendarType"
import MainMargins from "@/managers/system/mainMargins"
import router from "@/plugins/router"
import {Vue} from "@/mixins/combinations"
import {when} from "@/store/store"
import Vuetify from "@/plugins/vuetify"

type Route = {path: string, query?: Record<string, string>}

export function calendarTypeToRoute(type: CalendarType): Route {
	switch (type) {
		case CalendarType.list:
			return {path: "calendar"}
		case CalendarType.gridMonth:
			return {path: "calendar-month"}
		case CalendarType.gridWeek:
			return {path: "calendar-grid", query: {cols: "7"}}
		case CalendarType.grid4Day:
			return {path: "calendar-grid", query: {cols: "4"}}
	}
}

export function getScrollTop(query: string): number | null {
	const element = document.querySelector(query)
	if (element) {
		const rect = element.getBoundingClientRect()
		return rect.top - MainMargins.top
	}
	return null
}

export function scrollToHashWhenReady(readyFunction: () => boolean): void {
	if (router.currentRoute.hash)
		when(readyFunction)
			.then(() => Vue.nextTick())
			.then(() => {
				const top = getScrollTop(router.currentRoute.hash)

				if (top !== null)
					Vuetify.framework.goTo(top)
			})
}

export {CalendarType, Route}
